<div class="haul-screen">
  <section class="hero-card">
    <div class="hero-header">
      <div class="hero-title">{{ data?.title }}</div>
      <button type="button" class="reset-button" (click)="resetFilters()">
        {{ data?.resetLabel || 'Reset Filter' }}
      </button>
    </div>

    <div class="hero-filters">
      <app-global-dropdown
        *ngFor="let filter of headerFilters; trackBy: trackByLabel"
        [(ngModel)]="filterSelections[filter.key]"
        [data]="filter"
        [options]="filter.options || []"
      ></app-global-dropdown>
    </div>
  </section>

  <div class="content-grid">
    <div class="left-column">
      <section #noteCardRef class="panel note-card">
        <div class="note-line">{{ noteText }}</div>
        <app-number-stats #topStatHostRef [data]="topStat"></app-number-stats>
      </section>

      <section class="panel variable-card">
        <h3 class="section-title">Variable Inputs</h3>
        <div class="variable-row" *ngFor="let item of variableInputs; trackBy: trackByLabel">
          <label>{{ item.label }}</label>
          <input
            type="number"
            [(ngModel)]="item.value"
            [step]="item.step || 0.1"
          />
        </div>
      </section>

      <section class="panel cost-table-card">
        <div class="table-label">{{ data?.costTable?.title }}</div>
        <div class="table-scroller">
          <table class="cost-table">
            <thead>
              <tr>
                <th *ngFor="let column of data?.costTable?.columns">{{ column }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of costRows; trackBy: trackByLabel"
                [class.group-row]="row.variant === 'group'"
                [class.total-row]="row.variant === 'total'"
                [class.summary-row]="row.variant === 'summary'"
                [class.child-row]="row.indent"
              >
                <td [class.indented]="row.indent">{{ row.label }}</td>
                <td>{{ row.tco }}</td>
                <td>{{ row.share }}</td>
                <td>{{ row.amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div class="right-column">
      <section class="panel maintenance-card">
        <h3 class="section-title">Maintenance Schedules &amp; Cost</h3>

        <multiselect-toggle
          [data]="data?.toggleConfig"
          (selectionChange)="onToggleSelectionChange($event)"
        ></multiselect-toggle>

        <div class="unit-cost-header">
          <span>Unit Cost</span>
          <span>Overridable Unit Cost</span>
        </div>
        <div class="unit-cost-row" *ngFor="let row of maintenanceRows; trackBy: trackByLabel">
          <span>{{ row.label }}</span>
          <span>{{ row.value }}</span>
          <span>{{ row.override || '-' }}</span>
        </div>

        <div class="checkbox-section">
          <div class="checkbox-title">Optional D Check Parts</div>
          <label class="checkbox-row" *ngFor="let part of optionalParts; trackBy: trackByLabel">
            <input type="checkbox" [(ngModel)]="part.selected" />
            <span>{{ part.label }}</span>
          </label>
          <div class="inline-total">
            <span>D Check Total with Optional Parts</span>
            <strong>${{ optionalPartsTotal }}</strong>
          </div>
        </div>

        <div class="checkbox-section">
          <div class="checkbox-title">Optional Parts for Overhaul</div>
          <label class="checkbox-row" *ngFor="let part of overhaulParts; trackBy: trackByLabel">
            <input type="checkbox" [(ngModel)]="part.selected" />
            <span>{{ part.label }}</span>
          </label>
        </div>
      </section>

      <section class="panel editable-card">
        <h3 class="section-title">{{ data?.editableTable?.title }}</h3>
        <div class="table-scroller compact">
          <table class="editable-table">
            <thead>
              <tr>
                <th *ngFor="let column of data?.editableTable?.columns">{{ column }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of editableRows; trackBy: trackByLabel">
                <td>{{ row.label }}</td>
                <td><input type="number" [(ngModel)]="row.value" /></td>
                <td><input type="number" [(ngModel)]="row.override" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="stats-stack">
        <app-number-stats
          *ngFor="let stat of bottomStats; trackBy: trackByLabel"
          [data]="stat"
        ></app-number-stats>
      </section>
    </div>
  </div>
</div>
